import React, { useEffect, useState /*useMemo*/ } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
//import debounce from 'lodash.debounce';
//-Dependencias
// import Column from "./assets/colums/columns.jsx"
import {
  createRow,
  formatResultConcentrators,
} from "../../../helpers/tableFunctions";
//import { organizationsAgenciesToSearchBar } from "../../../store/slices/gammaSlice"
import styles from "./Concentrators.module.css";
import { SearchBar } from "../../Shared/SearchBar/SearchBar";
//import { agencieSearch } from "../../../api/agencies/AgenciesService"
// import { getOrganizationAgencies } from "../../../api/gamma"
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
// import usePagination from "./Pagination.jsx"
import {
  PointsChangePage,
  setPointCriteria,
  setPointItem,
} from "../../../store/slices/paginationSlice";
// import Loader from "../../Shared/Loader";
import { useTranslation } from "react-i18next";
//-Material
import {
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Table,
  Grid,
  CircularProgress,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import HandleRequest from "../../Shared/handleRequests/HandleRequests";
// import {organizationAgenciesUpdate} from "../../../store/slices/gammaSlice";
import { gammaServices } from "../../../api/gamma/index";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import ModalConcentrators from "./Modal/ModalConcentrators";

const Concentrators = () => {
  const gammaService = gammaServices;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // LOCALES
  const [concentrators, setConcentrators] = useState([]);
  // const [ primaryColor, setPrimaryColor ] = useState("");
  // const [ ligthPrimaryColor, setLightPrimaryColor ] = useState("")
  const [agenciesToSearch, setAgenciesToSearch] = useState([]);
  // REDUX
  // const allConcentrators = useSelector((state) => state.gamma?.organizationAgencies?.content);
  const organizationsToSearch = useSelector(
    (state) => state.gamma?.organizationAgenciesSearch?.content,
  );
  // const organizationAgencies  = useSelector((state) => state.gamma?.organizationAgencies);
  const { activeOrganization } = useSelector((state) => state.gamma);
  const { textColor } = useSelector((state) => state.local);
  // const colors = useSelector((state) => state.local.uiConfig);
  const reduxPage = useSelector((state) => state.pagination.PointsActualPage);
  const reduxCriteria = useSelector((state) => state.pagination.PointsCriteria);
  const reduxItem = useSelector((state) => state.pagination.PointsItem);
  const { loadingPoints } = useSelector((state) => state.pagination);
  const backErrors = useSelector((state) => state.errors.concentratorsError);

  // NEED
  let id_agency = activeOrganization?.id;
  // const Columns = Column()

  // const totalPages = organizationAgencies?.totalPages

  // const _PAGINATION = usePagination(actualPage, totalPages, id_agency)

  const { t } = useTranslation();

  const [pages, setPages] = useState(1);
  const [actualPage, setActualPage] = useState(reduxPage);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState({
    item: reduxItem,
    criteria: reduxCriteria,
  });

  const [perPage, setPerPage] = useState(10);
  const [manualPagination, setManualPagination] = useState(actualPage);

  const [openModal, setOpenModal] = useState(false);
  const [searching, setSearching] = useState(false);
  const [filters, setFilters] = useState({
    status: "any",
    name: "",
    number: 0,
  });

  const handleChangePerPage = (e) => {
    setPerPage(e * 1);
    setActualPage(1);
  };

  const handleChangeSort = (e) => {
    setSort((prev) => ({
      ...prev,
      item: e,
      criteria: prev.criteria === "ASC" ? "DESC" : "ASC",
    }));
    dispatch(setPointCriteria(sort.criteria === "ASC" ? "DESC" : "ASC"));
    dispatch(setPointItem(e));
  };

  const handlePagination = (e, p) => {
    // _PAGINATION.jump(p)
    setActualPage(p);
    dispatch(PointsChangePage(p));
  };

  useEffect(() => {
    setAgenciesToSearch(organizationsToSearch);
  }, [organizationsToSearch]);

  useEffect(() => {
    setLoading(true);
    if (searching) {
      gammaService
        .getFilteredAgencies(
          id_agency,
          actualPage,
          perPage,
          sort?.criteria,
          sort?.item,
          filters,
          dispatch,
        )
        .then((response) => response.json())
        .then((res) => {
          setPages(res.totalPages);
          setConcentrators(res.content);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      gammaService
        .getOrganizationSortedAgencies(
          id_agency,
          actualPage,
          perPage,
          sort?.criteria,
          sort?.item,
          dispatch,
        )
        .then((res) => {
          setPages(res.totalPages);
          setConcentrators(res.content);
          setLoading(false);
        })
        .catch((err) => console.log(err));
    }
  }, [actualPage, sort, perPage, searching]);

  const handleOnClick = (obj) => {
    navigate(
      `./${obj.name.replaceAll(" ", "-")}/${obj.number}-${obj.subNumber || 0}/${obj.id}`,
    );
  };

  // useEffect(() => {
  //     _PAGINATION.jump(actualPage)
  //     // No agregar la dependencia _PAGINATION!
  //     // eslint-disable-next-line
  // }, [actualPage])

  // useEffect(() => {
  //     setConcentrators(allConcentrators);
  //     // setPrimaryColor(colors?.primary?.main);
  //     // setLightPrimaryColor(colors?.primary?.light)
  // }, [allConcentrators, colors])
  const handleOpen = () => setOpenModal(true);

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: "0.9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  };

  return (
    <div className={styles.container}>
      <HandleRequest error={backErrors} loading={loadingPoints}>
        <Grid container className={styles.header}>
          <Grid
            item
            lg={4}
            md={5}
            xs={12}
            className={styles.titleConcentrators}
          >
            <PointOfSaleIcon
              sx={{ fontSize: "1.8rem", color: "primary.main" }}
            />
            <h1 className={styles.title}>{t("points")}</h1>
          </Grid>
          <Grid item xs={12} md={5} lg={5} className={styles.filters}>
            <Button
              variant="contained"
              className={styles.filterButton}
              onClick={handleOpen}
            >
              <TuneRoundedIcon
                sx={{ color: "secondary.light", fontSize: "1.5rem" }}
              />
              <p>{t("filter")}</p>
            </Button>
            {searching && (
              <Button
                variant="contained"
                className={styles.filterButton}
                onClick={() => {
                  setFilters({
                    status: "any",
                    name: "",
                    number: 0,
                  });
                  setSearching(false);
                }}
              >
                <p>{t("clearFilters")}</p>
              </Button>
            )}
          </Grid>
        </Grid>
        <div className={styles.tableContainer}>
          {loading ? (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
              }}
            >
              <CircularProgress size={"3rem"} />
            </Grid>
          ) : !concentrators.length ? (
            <Grid item xs={12} className={styles.noResults}>
              <p>{t("noResults")}</p>
            </Grid>
          ) : (
            <TableContainer className={styles.table}>
              <Table stickyHeader>
                <TableHead className={styles.tableHead}>
                  <TableRow
                    color={"primary.main"}
                    sx={{
                      backgroundColor: "primary.main",
                      "&:hover": { backgroundColor: "secondary.light" },
                    }}
                  >
                    {createRow(
                      `${t("number")} ${sort?.item === "number" ? (sort?.criteria === "ASC" ? "▼" : "▲") : ""}`,
                      "left",
                      false,
                      {
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: "1rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                        cursor: "pointer",
                      },
                      () => {
                        handleChangeSort("number");
                      },
                    )}
                    {createRow(
                      `${t("name")} ${sort?.item === "name" ? (sort?.criteria === "ASC" ? "▼" : "▲") : ""}`,
                      "left",
                      false,
                      {
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: "1rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                        cursor: "pointer",
                      },
                      () => {
                        handleChangeSort("name");
                      },
                    )}
                    {createRow(`${t("type")}`, "left", false, {
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "1rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    })}
                    {createRow(`${t("state")}`, "left", false, {
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "1rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {concentrators?.map((concentrator, i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          {createRow(
                            concentrator.agencyLevel !== "CONCENTRATOR"
                              ? concentrator.number !== null &&
                                  `${concentrator.number}-${concentrator.subNumber || "0"}`
                              : concentrator.number !== null &&
                                  `${concentrator.number}`,
                            "left",
                            i % 2 === 0,
                            cellStyles,
                            () => handleOnClick(concentrator),
                          )}
                          {createRow(
                            concentrator.name,
                            "left",
                            i % 2 === 0,
                            cellStyles,
                            () => handleOnClick(concentrator),
                          )}
                          {createRow(
                            concentrator.agencyLevel === "CONCENTRATOR"
                              ? t("concentrator")
                              : "-",
                            "left",
                            i % 2 === 0,
                            cellStyles,
                            () => handleOnClick(concentrator),
                          )}
                          {createRow(
                            concentrator.status === "DISABLED"
                              ? "DESHABILITADO"
                              : "HABILITADO",
                            "left",
                            i % 2 === 0,
                            cellStyles,
                            () => handleOnClick(concentrator),
                          )}
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
        {concentrators.length ? (
          <Grid
            item
            container
            xs={12}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              mb: 5,
              mt: 5,
            }}
          >
            <Grid
              item
              xs={12}
              md={2}
              sx={{
                mb: 3,
                mt: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Select
                value={perPage}
                onChange={(e) => handleChangePerPage(e.target.value)}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                mb: 3,
                mt: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Pagination
                showFirstButton
                showLastButton
                count={pages || 1}
                page={actualPage || 1}
                siblingCount={0}
                onChange={handlePagination}
                color={"primary"}
                disabled={loading}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              sx={{
                mb: 3,
                mt: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <form>
                <input
                  type="number"
                  className={styles.insertPaginate}
                  onChange={(e) => setManualPagination(e.target.value * 1)}
                />
                <Button
                  sx={{ ml: 1 }}
                  variant="contained"
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    if (manualPagination <= pages) {
                      handlePagination(null, manualPagination);
                    }
                  }}
                >
                  Ir
                </Button>
              </form>
            </Grid>
          </Grid>
        ) : null}
      </HandleRequest>
      <ModalConcentrators
        open={openModal}
        setOpen={setOpenModal}
        filters={filters}
        setFilters={setFilters}
        setSearching={setSearching}
      />
    </div>
  );
};

export default Concentrators;
